enum Package {
    BASIC = 'BASIC',
    ENTREPRENEUR = 'ENTREPRENEUR',
    INSTITUTION = 'INSTITUTION',
}

export default Package;
